<mat-form-field>
    <mat-label>Select a Custom Deal Type</mat-label>
    <mat-select
        [(ngModel)]="selectedValue"
        name="templateGroup"
        (selectionChange)="sortByProducts($event.value)"
        [disabled]="templateGroupSelection?.groupName"
    >
        <mat-option *ngFor="let group of groups" [value]="group">{{ group.groupName }} </mat-option>
    </mat-select>
</mat-form-field>
